"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var elog = require("../../elog");
var core_link_1 = require("../../components/core_link");
var markdown_output_1 = require("./markdown_output");
var url_helpers_1 = require("../../url_helpers");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../../tracker");
var COMPONENT_NAME = 'ImageEmbed';
var ImageEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(ImageEmbed, _super);
    function ImageEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ImageEmbed.prototype, "imageURI", {
        get: function () {
            return url_helpers_1.imageUploadURL(this.props.image_key, this.props.cdn);
        },
        enumerable: true,
        configurable: true
    });
    ImageEmbed.prototype.renderImage = function () {
        return (React.createElement("img", { src: this.imageURI }));
    };
    ImageEmbed.prototype.renderImageLink = function () {
        if (!this.props.url) {
            return this.renderImage();
        }
        if (this.props.url.startsWith('http')) {
            return (React.createElement("a", { href: this.props.url, target: "_blank", rel: "noopener noreferrer nofollow" }, this.renderImage()));
        }
        return (React.createElement(core_link_1.default, { to: this.props.url }, this.renderImage()));
    };
    ImageEmbed.prototype.render = function () {
        try {
            var classes = classNames('image-embed', { 'image-embed--left': this.props.alignment === 'left' }, { 'image-embed--right': this.props.alignment === 'right' }, { 'image-embed--center': this.props.alignment === 'center' });
            return (React.createElement("div", { className: classes },
                React.createElement("div", { className: "image-embed__inner" },
                    this.renderImageLink(),
                    React.createElement(markdown_output_1.default, { text: this.props.caption, textHtml: this.props.captionHtml, markdownParser: this.props.markdownParser, className: "image-embed__caption" }))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    ImageEmbed = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                eventType: tracker_1.VIEW,
                context: {
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                },
            };
        }, { dispatchOnMount: true })
    ], ImageEmbed);
    return ImageEmbed;
}(React.Component));
exports.default = ImageEmbed;
//# sourceMappingURL=image_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/image_embed.js
// module id = l+Px
// module chunks = 0 2 6 20